import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-two-four-one-one',
  templateUrl: './two-four-one-one.component.html',
  styleUrls: ['./two-four-one-one.component.scss']
})
export class TwoFourOneOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
